import { render, staticRenderFns } from "./DailyBoxShow.vue?vue&type=template&id=40ac2950"
import script from "./DailyBoxShow.vue?vue&type=script&lang=js"
export * from "./DailyBoxShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports